var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorInternal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_413_15977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.529 92.3754L77.0055 12.3017C73.6869 6.81909 67.916 3.50049 61.4955 3.50049C55.075 3.50049 49.3041 6.81909 45.9855 12.3017C45.9855 12.3733 45.9139 12.3733 45.9139 12.4459L2.53418 92.2312C-0.783941 97.9303 -0.856011 104.711 2.39004 110.411C5.63609 116.109 11.4791 119.5 18.044 119.5H104.947C111.512 119.5 117.355 116.109 120.601 110.411C123.847 104.711 123.775 97.9301 120.529 92.3754Z",
    fill: "#FEA832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0423 112.285C14.0479 112.285 10.6313 110.299 8.65875 106.84C6.68618 103.377 6.72126 99.3725 8.77142 95.8572L51.8227 16.6806L53.1611 15.3105L53.168 14.6165C55.2391 12.1471 58.2403 10.7139 61.495 10.7139C65.3273 10.7139 68.8217 12.704 70.8366 16.0363L114.184 95.8079C116.27 99.3797 116.277 103.427 114.332 106.84C112.36 110.299 108.943 112.285 104.949 112.285H18.0423Z",
    fill: "#FEDB41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.601 110.41C117.355 116.108 111.512 119.499 104.947 119.499H61.4956V3.50049C67.9159 3.50049 73.687 6.81909 77.0056 12.3017L120.529 92.3751C123.775 97.9298 123.847 104.711 120.601 110.41Z",
    fill: "#FE9923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.949 112.285C108.943 112.285 112.36 110.299 114.332 106.84C116.277 103.427 116.27 99.3797 114.184 95.8079L70.8369 16.0358C68.822 12.7037 65.3278 10.7134 61.4954 10.7134V112.285H104.949V112.285Z",
    fill: "#FFCC33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7095 40.1469V69.0024C68.7095 72.9702 65.4632 76.2162 61.4957 76.2162C57.5283 76.2162 54.282 72.9699 54.282 69.0024V40.1469C54.282 36.1792 57.5283 32.9331 61.4957 32.9331C65.4632 32.9331 68.7095 36.1792 68.7095 40.1469Z",
    fill: "#495A79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7096 40.1469V69.0024C68.7096 72.9702 65.4633 76.2162 61.4958 76.2162V32.9331C65.4631 32.9331 68.7096 36.1792 68.7096 40.1469Z",
    fill: "#42516D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4956 83.4297C55.5077 83.4297 50.6747 88.2627 50.6747 94.2506C50.6747 100.238 55.5077 105.071 61.4956 105.071C67.4834 105.071 72.3165 100.238 72.3165 94.2506C72.3165 88.263 67.4832 83.4297 61.4956 83.4297Z",
    fill: "#495A79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3165 94.2508C72.3165 100.238 67.4835 105.072 61.4956 105.072V83.4302C67.4832 83.4299 72.3165 88.2632 72.3165 94.2508Z",
    fill: "#42516D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_413_15977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 123,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorInternal);
export default __webpack_public_path__ + "static/media/error_internal.2cd8af99e5acde1ca3381cee85b04a4e.svg";
export { ForwardRef as ReactComponent };